import React from 'react'
import Result from './Result'

export default function Results({ inputItems, getItemProps, highlightedIndex }) {
  const RenderedItems = []
  for (let i = 0; i < inputItems.length; i++) {
    RenderedItems.push(
      <Result
        item={inputItems[i]}
        index={i}
        key={`${i}-${inputItems[i].id}`}
        getItemProps={getItemProps}
        highlightedIndex={highlightedIndex}
      />
    )
  }
  return <>{RenderedItems}</>
}
